import { useDiffMerge } from "@Context/prompt-toolbox/DiffMergeContext";
import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";
import { usePromptToolboxContext } from "@Context/prompt-toolbox/PromptToolboxContext";

const ResetVersion = () => {
  const { selectedPromptVersion } = usePromptToolboxContext();
  const { setModal } = useUtilityContext();
  const { setEdited } = useDiffMerge();

  const handleReset = () => {
    setEdited(selectedPromptVersion!.version.prompt);
    setModal("resetVersion", false);
  };

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label>{"This will erase your current changes."}</label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button data-testid="modal-reset-button"
            onClick={handleReset}
            className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Reset
          </button>
          <button data-testid="reset-modal-cancel-button"
            onClick={() => setModal("resetVersion", false)}
            className="rounded-md bg-primary-700 px-4 py-2 text-white"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default ResetVersion;
